function getGenderDisplay(gender){
    if(gender === 'male') return "Herr";
    else if(gender === 'female') return "Frau";
    else if(gender === 'other') return "Herr/Frau";
}

export default getGenderDisplay;